module.exports = __webpack_public_path__ + "img/phone.c0cdbb81.svg";